import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ObjectExtensionConstants {
  static readonly IdentityUserOrganizationUnitId = 'OrganizationUnitId';
  static readonly IdentityUserOrganizationUnitDisplayName = 'OrganizationUnitDisplayName';
}
